import {
    put,
    call,
    all,
    takeLatest
} from "redux-saga/effects";

import { axiosGet, axiosPost } from "../util/axios";
import { HTTP_SUCCESS_STATUSES as HTTP_SUCCESS_STATUS } from "../constants/http_constants";
import * as actionType from "../constants/action_types";
import * as actions from "../actions/index";
import { toast } from "react-toastify";



// ------------------------GET REQUEST START ------------------------
function* getConnectProvider(action) {
    try {
        yield put(actions.RESET_STATE("connect.provider"));
        const url = `connect/${action.payload.company_uid}/provider`;
        const { data: axiosData } = yield call(axiosGet, url);
        const { data, type, title, message } = axiosData; // Getting zuper response
        if (type?.toString()?.toUpperCase() != 'SUCCESS') {
            throw new Error(`${axiosData?.status} ` + message, {
                cause: message || title
            });
        }
        yield put(actions.GET_CONNECT_PROVIDER_RES({ data: data }));
    } catch (error) {
        console.error(error);
        yield put(actions.GET_CONNECT_PROVIDER_RES({
            data: {
                type: 'error',
                error: error?.message || error?.title || error
            }
        }));
        toast(error?.cause || "Error in getting Zuper Connect Providers.", {
            type: "error",
        });
    } finally {
        yield put(actions.STOP_LOADER);
    }
}


function* getConnectAgents(action) {
    try {
        yield put(actions.RESET_STATE("connect.agents"));
        const url = `connect/${action.payload.company_uid}/agent/users`;
        const { data: axiosData } = yield call(axiosPost, url);
        const { data, type, title, message } = axiosData; // Getting zuper response
        if (type?.toString()?.toUpperCase() != 'SUCCESS') {
            throw new Error(`${axiosData?.status} ` + message, {
                cause: message || title
            });
        }
        yield put(actions.GET_CONNECT_AGENT_RES({ data: data }));
    } catch (error) {
        console.error(error);
        yield put(actions.GET_CONNECT_AGENT_RES({
            data: {
                type: 'error',
                error: error?.message || error?.title || error
            }
        }));
        toast(error?.cause || "Error in getting Zuper Connect Agents.", {
            type: "error",
        });
    } finally {
        yield put(actions.STOP_LOADER);
    }
}

// ------------------------GET REQUEST ENDS ------------------------

// ------------------------POST REQUEST START ----------------------

function* addConnectProvider(action) {
    try {
        const url = `connect/${action.payload.company_uid}/provider`;
        let { data, status } = yield call(axiosPost, url, {
            providerDetails: action.payload.providerDetails,
        });
        if (HTTP_SUCCESS_STATUS.includes(status)) {
            yield put(actions.GET_CONNECT_PROVIDER_REQ(action.payload));
        } else {
            throw new Error(data?.message || data?.error?.message);
        }
    } catch (error) {
        toast(error.message || "Error in adding Zuper Connect provider.", {
            type: "error",
        });
    } finally {
        yield put(actions.STOP_LOADER);
    }
}


function* addConnectAgents(action) {
    try {
        const url = `connect/${action.payload.company_uid}/agent/add_agents`;
        let { data, status } = yield call(axiosPost, url, {
            user_uid: action.payload.user_uid,
        });
        if (HTTP_SUCCESS_STATUS.includes(status)) {
            toast(data.message || "Successfully added agent(s)", {
                type: "success",
            });
            // Refresh agent list after successful assignment
            yield put(actions.GET_CONNECT_AGENT_REQ({ company_uid: action.payload.company_uid }));
        } else {
            throw new Error(data?.message || data?.error?.message);
        }
    } catch (error) {
        toast(error.message || "Error in adding Zuper Connect Agents.", {
            type: "error",
        });
        // Agents have already been assigned getting the agents again
        if (error?.message === 'Agents already assigned') {
            yield put(actions.GET_CONNECT_AGENT_REQ({ company_uid: action.payload.company_uid }));
        }
    } finally {
        yield put(actions.STOP_LOADER);
    }
}


// ------------------------POST REQUEST ENDS ----------------------



function* connectWatcherSaga() {
    yield all([
        // GET API
        takeLatest(actionType.GET_CONNECT_AGENT_REQ, getConnectAgents),
        takeLatest(actionType.GET_CONNECT_PROVIDER_REQ, getConnectProvider),
        // POST API
        takeLatest(actionType.ADD_CONNECT_AGENT_REQ, addConnectAgents),
        takeLatest(actionType.ADD_CONNECT_PROVIDER_REQ, addConnectProvider),
    ]);
}

export default connectWatcherSaga;
